"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_BLUEPRINT = exports.getFieldBlueprintBase = exports.questionnaireBlueprintCopyableOptions = exports.QuestionnaireBlueprintCopyableOptions = exports.informationFieldBlueprintVariant = exports.InformationFieldBlueprintVariants = exports.InputFieldValidations = exports.AlwaysValidOptions = exports.PhoneFieldValidations = exports.StringFieldValidations = exports.BooleanFieldValidations = exports.DateFieldValidations = exports.MoneyFieldValidations = exports.NumberFieldValidations = exports.questionnaireBlueprintRenderOn = exports.QuestionnaireBlueprintRenderOns = void 0;
exports.isSectionBlueprint = isSectionBlueprint;
exports.isSubsectionBlueprint = isSubsectionBlueprint;
exports.isFieldGroupBlueprint = isFieldGroupBlueprint;
exports.isFieldBlueprint = isFieldBlueprint;
exports.isSelectOptionBlueprint = isSelectOptionBlueprint;
exports.isSelectOptionFieldBlueprintType = isSelectOptionFieldBlueprintType;
exports.isSelectOptionFieldBlueprint = isSelectOptionFieldBlueprint;
exports.isCheckBoxGroupFieldBlueprint = isCheckBoxGroupFieldBlueprint;
exports.isDropdownFieldBlueprint = isDropdownFieldBlueprint;
exports.isButtonFieldBlueprint = isButtonFieldBlueprint;
exports.isInformationFieldBlueprint = isInformationFieldBlueprint;
exports.isAddressAutocompleteFieldBlueprint = isAddressAutocompleteFieldBlueprint;
exports.isRadioFieldBlueprint = isRadioFieldBlueprint;
exports.isAgreeFieldBlueprint = isAgreeFieldBlueprint;
exports.isNumberFieldBlueprint = isNumberFieldBlueprint;
exports.isInputFieldBlueprint = isInputFieldBlueprint;
exports.isMoneyFieldBlueprint = isMoneyFieldBlueprint;
exports.isTextareaFieldBlueprint = isTextareaFieldBlueprint;
exports.isCheckboxFieldBlueprint = isCheckboxFieldBlueprint;
exports.isSignatureFieldBlueprint = isSignatureFieldBlueprint;
exports.isQuoterSubsectionBlueprint = isQuoterSubsectionBlueprint;
exports.isTextFieldBlueprint = isTextFieldBlueprint;
exports.isAcceptingDefaultValueField = isAcceptingDefaultValueField;
exports.everyIDsAreUnique = everyIDsAreUnique;
exports.createQuestionnaireNodeLookup = createQuestionnaireNodeLookup;
exports.generateRepeatableParentsMap = generateRepeatableParentsMap;
const typegate_1 = require("typegate");
const fieldTypes_1 = require("../carrierQuestionnaire/fieldTypes");
const subsectionVariant_1 = require("../carrierQuestionnaire/subsectionVariant");
const ReferenceLabel_1 = require("./ReferenceLabel");
exports.QuestionnaireBlueprintRenderOns = {
    web: 'web',
    pdf: 'pdf',
    summary: 'summary',
};
exports.questionnaireBlueprintRenderOn = typegate_1.t.union(typegate_1.t.literal('web'), typegate_1.t.literal('pdf'), typegate_1.t.literal('summary'));
exports.NumberFieldValidations = {
    integer: 'integer',
    decimal: 'decimal',
    percentage: 'percentage',
};
exports.MoneyFieldValidations = {
    integer: 'integer',
    decimal: 'decimal',
};
exports.DateFieldValidations = {
    date: 'date',
    pastDate: 'pastDate',
    yearMonth: 'yearMonth',
    yearMonthPastDate: 'yearMonthPastDate',
    yearMonthFutureDate: 'yearMonthFutureDate',
    yearMonthPastOrCurrentDate: 'yearMonthPastOrCurrentDate',
    yearMonthFutureOrCurrentDate: 'yearMonthFutureOrCurrentDate',
    futureDate: 'futureDate',
    futureOrCurrentDate: 'futureOrCurrentDate',
    pastOrCurrentDate: 'pastOrCurrentDate',
    currentDate: 'currentDate',
};
exports.BooleanFieldValidations = {
    boolean: 'boolean',
    booleanTrue: 'booleanTrue',
};
exports.StringFieldValidations = {
    string: 'string',
};
exports.PhoneFieldValidations = {
    phone: 'phone',
};
exports.AlwaysValidOptions = {
    signature: 'signature',
};
exports.InputFieldValidations = {
    string: 'string',
    email: 'email',
    firstName: 'firstName',
    lastName: 'lastName',
    middleName: 'middleName',
    sin: 'sin',
    canadianPostalCode: 'canadianPostalCode',
    zipCode: 'zipCode',
    branchNumber: 'branchNumber',
    institutionNumber: 'institutionNumber',
    accountNumber: 'accountNumber',
    ssn: 'ssn',
};
// TODO: move InfoVariants out of shared/questionnaire and use that.
exports.InformationFieldBlueprintVariants = {
    warning: 'warning',
    error: 'error',
    success: 'success',
    info: 'info',
    paragraph: 'paragraph',
};
exports.informationFieldBlueprintVariant = typegate_1.t.union(typegate_1.t.literal('warning'), typegate_1.t.literal('error'), typegate_1.t.literal('success'), typegate_1.t.literal('info'), typegate_1.t.literal('paragraph'));
exports.QuestionnaireBlueprintCopyableOptions = {
    none: 'none',
    insured: 'insured',
    owner: 'owner',
};
exports.questionnaireBlueprintCopyableOptions = typegate_1.t.union(typegate_1.t.literal('none'), typegate_1.t.literal('insured'), typegate_1.t.literal('owner'));
const getFieldBlueprintBase = (field) => {
    // This function is usefule to go from one field type to another one.
    // You transfer everything that is shared amongst them, but nothing more.
    // That would alleviate some of the pressure of properties are kept on
    // fields when we change the field.type. (Would prefer constructor for each one tho)
    const fieldWithKeysEvenIfUndefined = {
        id: field.id,
        partName: field.partName,
        referenceLabel: field.referenceLabel,
        text: field.text,
        title: field.title,
        visible: field.visible,
        dataLabel: field.dataLabel,
        platforms: field.platforms,
        renderOn: field.renderOn,
        hidden: field.hidden,
        isCustom: field.isCustom,
        copyable: field.copyable,
        answerNodeId: field.answerNodeId,
        valid: field.valid,
        optional: field.optional,
        disabled: field.disabled,
        infoSupplement: field.infoSupplement,
        placeholder: field.placeholder,
        iconName: field.iconName,
        triggerStepNavigation: field.triggerStepNavigation,
        layout: field.layout,
        displayInCardPreview: field.displayInCardPreview,
        dynamicOptions: field.dynamicOptions,
        internal: field.internal,
        effects: field.effects,
        applicationModes: field.applicationModes,
    };
    Object.keys(fieldWithKeysEvenIfUndefined).forEach((key) => {
        if (fieldWithKeysEvenIfUndefined[key] === undefined) {
            delete fieldWithKeysEvenIfUndefined[key];
        }
    });
    return fieldWithKeysEvenIfUndefined;
};
exports.getFieldBlueprintBase = getFieldBlueprintBase;
exports.DEFAULT_BLUEPRINT = {
    sectionBlueprints: [],
    sectionGroupBlueprints: {
        insuredPeople: { id: '24664fee-5bfa-4862-9049-42b636d5686c', partName: 'insuredPeople' },
    },
};
function isSectionBlueprint(questionnaireElementBlueprint) {
    return !!questionnaireElementBlueprint.subsections;
}
function isSubsectionBlueprint(questionnaireElementBlueprint) {
    return !!questionnaireElementBlueprint.fieldGroups;
}
function isFieldGroupBlueprint(questionnaireElementBlueprint) {
    return !!questionnaireElementBlueprint.fields;
}
function isFieldBlueprint(questionnaireElementBlueprint) {
    return !!questionnaireElementBlueprint.fieldType;
}
function isSelectOptionBlueprint(questionnaireElementBlueprint) {
    return (!isSectionBlueprint(questionnaireElementBlueprint) &&
        !isSubsectionBlueprint(questionnaireElementBlueprint) &&
        !isFieldGroupBlueprint(questionnaireElementBlueprint) &&
        !isFieldBlueprint(questionnaireElementBlueprint));
}
function isSelectOptionFieldBlueprintType(fieldType) {
    return fieldType === fieldTypes_1.FieldTypes.dropdown || fieldType === fieldTypes_1.FieldTypes.radio || fieldType === fieldTypes_1.FieldTypes.checkboxGroup;
}
function isSelectOptionFieldBlueprint(fieldBlueprint) {
    return (fieldBlueprint.fieldType === fieldTypes_1.FieldTypes.dropdown ||
        fieldBlueprint.fieldType === fieldTypes_1.FieldTypes.radio ||
        fieldBlueprint.fieldType === fieldTypes_1.FieldTypes.checkboxGroup);
}
function isCheckBoxGroupFieldBlueprint(fieldBlueprint) {
    return fieldBlueprint.fieldType === fieldTypes_1.FieldTypes.checkboxGroup;
}
function isDropdownFieldBlueprint(fieldBlueprint) {
    return fieldBlueprint.fieldType === fieldTypes_1.FieldTypes.dropdown;
}
function isButtonFieldBlueprint(fieldBlueprint) {
    return fieldBlueprint.fieldType === fieldTypes_1.FieldTypes.button;
}
function isInformationFieldBlueprint(fieldBlueprint) {
    return fieldBlueprint.fieldType === fieldTypes_1.FieldTypes.information;
}
function isAddressAutocompleteFieldBlueprint(fieldBlueprint) {
    return fieldBlueprint.fieldType === fieldTypes_1.FieldTypes.autocomplete;
}
function isRadioFieldBlueprint(fieldBlueprint) {
    return fieldBlueprint.fieldType === fieldTypes_1.FieldTypes.radio;
}
function isAgreeFieldBlueprint(fieldBlueprint) {
    return fieldBlueprint.fieldType === fieldTypes_1.FieldTypes.agree;
}
function isNumberFieldBlueprint(fieldBlueprint) {
    return fieldBlueprint.fieldType === fieldTypes_1.FieldTypes.number;
}
function isInputFieldBlueprint(fieldBlueprint) {
    return fieldBlueprint.fieldType === fieldTypes_1.FieldTypes.input;
}
function isMoneyFieldBlueprint(fieldBlueprint) {
    return fieldBlueprint.fieldType === fieldTypes_1.FieldTypes.money;
}
function isTextareaFieldBlueprint(fieldBlueprint) {
    return fieldBlueprint.fieldType === fieldTypes_1.FieldTypes.textarea;
}
function isCheckboxFieldBlueprint(fieldBlueprint) {
    return fieldBlueprint.fieldType === fieldTypes_1.FieldTypes.checkbox;
}
function isSignatureFieldBlueprint(fieldBlueprint) {
    return fieldBlueprint.fieldType === fieldTypes_1.FieldTypes.signature;
}
function isQuoterSubsectionBlueprint(subsection) {
    const quoterSubsection = subsection;
    return quoterSubsection.variant?.type === subsectionVariant_1.SubsectionVariants.quoter && !!quoterSubsection.variant?.productNodeIds;
}
function isTextFieldBlueprint(fieldType) {
    const textFieldTypes = [
        fieldTypes_1.FieldTypes.input,
        fieldTypes_1.FieldTypes.textarea,
        fieldTypes_1.FieldTypes.money,
        fieldTypes_1.FieldTypes.phone,
        fieldTypes_1.FieldTypes.dropdown,
        fieldTypes_1.FieldTypes.number,
        fieldTypes_1.FieldTypes.autocomplete,
        fieldTypes_1.FieldTypes.date,
    ];
    return textFieldTypes.includes(fieldType);
}
function isAcceptingDefaultValueField(fieldBlueprint) {
    return (!!fieldBlueprint.defaultValue ||
        isCheckboxFieldBlueprint(fieldBlueprint) ||
        isTextareaFieldBlueprint(fieldBlueprint) ||
        isInputFieldBlueprint(fieldBlueprint) ||
        isMoneyFieldBlueprint(fieldBlueprint) ||
        isSelectOptionFieldBlueprint(fieldBlueprint) ||
        isNumberFieldBlueprint(fieldBlueprint) ||
        isRadioFieldBlueprint(fieldBlueprint) ||
        isCheckBoxGroupFieldBlueprint(fieldBlueprint));
}
class DuplicateItemError extends Error {
    item1;
    item2;
    constructor(item1, item2) {
        super();
        this.item1 = item1;
        this.item2 = item2;
        this.message = `Two object in the blueprint have the same id = ${item1.id ? item1.id : 'undefined'}. The 1st item path is ".${item1.path}". The 2nd item path is ".${item2.path}".`;
    }
}
class ThrowingMap {
    map;
    constructor() {
        this.map = new Map();
    }
    add(id, pathNewItem) {
        const pathOriginalItem = this.map.get(id);
        if (pathOriginalItem) {
            throw new DuplicateItemError({ id, path: pathOriginalItem }, { id, path: pathNewItem });
        }
        this.map.set(id, pathNewItem);
    }
}
function everyIDsAreUnique(blueprint) {
    const existingIds = new ThrowingMap();
    const jqPaths = [];
    try {
        if (blueprint.sectionGroupBlueprints.contract) {
            existingIds.add(blueprint.sectionGroupBlueprints.contract.id, 'sectionGroupBlueprints.contract');
        }
        if (blueprint.sectionGroupBlueprints.insuredPeople) {
            existingIds.add(blueprint.sectionGroupBlueprints.insuredPeople.id, 'sectionGroupBlueprints.insured');
        }
        blueprint.sectionBlueprints.forEach((section, index) => {
            jqPaths.push(`sectionBlueprints[${index}]`);
            existingIds.add(section.id, jqPaths.join('.'));
            section.subsections.forEach((subsection, index) => {
                jqPaths.push(`subsections[${index}]`);
                existingIds.add(subsection.id, jqPaths.join('.'));
                subsection.fieldGroups.forEach((fieldGroup, index) => {
                    jqPaths.push(`fieldGroups[${index}]`);
                    existingIds.add(fieldGroup.id, jqPaths.join('.'));
                    fieldGroup.fields.forEach((field, index) => {
                        jqPaths.push(`fields[${index}]`);
                        existingIds.add(field.id, jqPaths.join('.'));
                        jqPaths.pop();
                    });
                    jqPaths.pop();
                });
                jqPaths.pop();
            });
            jqPaths.pop();
        });
    }
    catch (e) {
        if (e instanceof DuplicateItemError) {
            return (0, typegate_1.failure)(e.message);
        }
        else if (e instanceof Error) {
            return (0, typegate_1.failure)(e.message);
        }
        return (0, typegate_1.failure)('unknown error');
    }
    return (0, typegate_1.success)(undefined);
}
function createQuestionnaireNodeLookup(blueprint) {
    const result = {};
    const createAlreadyExistsError = (referenceLabel) => new ReferenceLabel_1.ReferenceLabelValidationError(`Reference labels must be unique and "${referenceLabel}" already exists.`);
    const createReferenceLabelMapping = (blueprintId, nodeId) => ({ blueprintId, nodeId });
    // Section Groups
    for (const sectionGroupKey in blueprint.sectionGroupBlueprints) {
        const sectionGroup = blueprint.sectionGroupBlueprints[sectionGroupKey];
        if (typeof sectionGroup !== 'object' || !sectionGroup?.referenceLabel) {
            continue;
        }
        const referenceLabel = ReferenceLabel_1.ReferenceLabel.create(sectionGroup.referenceLabel);
        if (referenceLabel.success === false) {
            return (0, typegate_1.failure)(referenceLabel.error);
        }
        const alreadyExists = result[referenceLabel.value.value];
        if (alreadyExists) {
            return (0, typegate_1.failure)(createAlreadyExistsError(referenceLabel.value.value));
        }
        result[referenceLabel.value.value] = createReferenceLabelMapping(sectionGroup.id, sectionGroup.repeatable?.repeatableAnswerNodeId);
    }
    // Sections
    for (const section of blueprint.sectionBlueprints) {
        if (section.referenceLabel) {
            const referenceLabel = ReferenceLabel_1.ReferenceLabel.create(section.referenceLabel);
            if (referenceLabel.success === false) {
                return (0, typegate_1.failure)(referenceLabel.error);
            }
            const alreadyExists = result[referenceLabel.value.value];
            if (alreadyExists) {
                return (0, typegate_1.failure)(createAlreadyExistsError(referenceLabel.value.value));
            }
            result[referenceLabel.value.value] = createReferenceLabelMapping(section.id);
        }
        // Subsections
        for (const subsection of section.subsections) {
            if (subsection.referenceLabel) {
                const referenceLabel = ReferenceLabel_1.ReferenceLabel.create(subsection.referenceLabel);
                if (referenceLabel.success === false) {
                    return (0, typegate_1.failure)(referenceLabel.error);
                }
                const alreadyExists = result[referenceLabel.value.value];
                if (alreadyExists) {
                    return (0, typegate_1.failure)(createAlreadyExistsError(referenceLabel.value.value));
                }
                result[referenceLabel.value.value] = createReferenceLabelMapping(subsection.id);
            }
            // fieldGroups
            for (const fieldGroup of subsection.fieldGroups) {
                if (fieldGroup.referenceLabel) {
                    const referenceLabel = ReferenceLabel_1.ReferenceLabel.create(fieldGroup.referenceLabel);
                    if (referenceLabel.success === false) {
                        return (0, typegate_1.failure)(referenceLabel.error);
                    }
                    const alreadyExists = result[referenceLabel.value.value];
                    if (alreadyExists) {
                        return (0, typegate_1.failure)(createAlreadyExistsError(referenceLabel.value.value));
                    }
                    result[referenceLabel.value.value] = createReferenceLabelMapping(fieldGroup.id, fieldGroup.repeatable?.repeatableAnswerNodeId);
                }
                // Fields
                for (const field of fieldGroup.fields) {
                    if (field.referenceLabel) {
                        const referenceLabel = ReferenceLabel_1.ReferenceLabel.create(field.referenceLabel);
                        if (referenceLabel.success === false) {
                            return (0, typegate_1.failure)(referenceLabel.error);
                        }
                        const alreadyExists = result[referenceLabel.value.value];
                        if (alreadyExists) {
                            return (0, typegate_1.failure)(createAlreadyExistsError(referenceLabel.value.value));
                        }
                        result[referenceLabel.value.value] = createReferenceLabelMapping(field.id, field.answerNodeId);
                    }
                }
            }
        }
    }
    return (0, typegate_1.success)(result);
}
function generateRepeatableParentsMap(blueprint) {
    const result = {
        byBlueprintId: new Map(),
        byNodeId: new Map(),
    };
    for (const sectionGroupKey in blueprint.sectionGroupBlueprints) {
        let sgBlueprintId = null;
        let sgNodeId = null;
        const sectionGroup = blueprint.sectionGroupBlueprints[sectionGroupKey];
        if (typeof sectionGroup !== 'object') {
            continue;
        }
        if (sectionGroup.repeatable && sectionGroup.repeatable.repeatableAnswerNodeId) {
            sgBlueprintId = sectionGroup.id;
            sgNodeId = sectionGroup.repeatable.repeatableAnswerNodeId;
        }
        for (const section of blueprint.sectionBlueprints) {
            if (section.sectionGroupKey != sectionGroupKey)
                continue;
            for (const subsection of section.subsections) {
                for (const fieldGroup of subsection.fieldGroups) {
                    let qBlueprintId = null;
                    let qNodeId = null;
                    if (fieldGroup.repeatable && fieldGroup.repeatable.repeatableAnswerNodeId) {
                        const qBlueprintIdParent = [sgBlueprintId].filter((e) => e != null);
                        if (qBlueprintIdParent.length) {
                            result.byBlueprintId.set(fieldGroup.id, qBlueprintIdParent);
                        }
                        const qNodeIdParent = [sgNodeId].filter((e) => e != null);
                        if (qNodeIdParent.length) {
                            result.byNodeId.set(fieldGroup.repeatable.repeatableAnswerNodeId, qNodeIdParent);
                        }
                        qBlueprintId = fieldGroup.id;
                        qNodeId = fieldGroup.repeatable.repeatableAnswerNodeId;
                    }
                    for (const field of fieldGroup.fields) {
                        const fieldBlueprintIdParent = [sgBlueprintId, qBlueprintId].filter((e) => e != null);
                        if (fieldBlueprintIdParent.length) {
                            result.byBlueprintId.set(field.id, fieldBlueprintIdParent);
                        }
                        const fieldNodeIdParent = [sgNodeId, qNodeId].filter((e) => e != null);
                        if (fieldNodeIdParent.length) {
                            result.byNodeId.set(field.answerNodeId, fieldNodeIdParent);
                        }
                    }
                }
            }
        }
    }
    return result;
}
